<template>
  <div class="com-story">
    <div class="tit" @click="showSetContEvent">
      {{tit}}
      <i class="icon-arrow el-icon-arrow-left" :class="{down: showSetCont}"></i>
    </div>
    <div class="author-info" :style="{'border-bottom': showSetCont ? '1px solid #f6f6f6': ''}">
      改编自：
      <span class="auth-avatar" :style="{'background-image': 'url(' + `http://iss.21teacher.com/avatar/125/${production.creatorId}/20.jpg` + ')'}"></span>
      <span class="name">{{production.creatorName}}</span>
    </div>
    <div class="set-cont" v-if="showSetCont" v-html="production.productionInrto">

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import productionApi from '@/api/production'
export default {
  props: {
    tit: String,
    proObjId: Number,
    proObjIndex:Number,
  },
  components: {},
  data () {
    return {
      showSetCont: false,
      production:{},
    }
  },
  computed: {},
  mounted () {
    if(this.proObjIndex == 0){
      this.showSetCont = true
    }

    productionApi.select(this.proObjId).then(data =>{

      this.production = data.response

    })

  },
  methods: {
    showSetContEvent () {
      this.showSetCont = !this.showSetCont
    }
  }
}
</script>

<style scoped lang="less">
.com-story{
  padding: 10px 0;
  border-bottom: 1px solid #f6f6f6;
  .tit{
    position: relative;
    padding-right: 30px;
    line-height: 30px;
    color: #333;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    .icon-arrow{
      position: absolute;
      right: 0;
      top: 0;
      width: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 20px;
      color: #1c82fe;
      transition: transform .3s;
      &.down{
        transform: rotate(-90deg);
      }
    }
  }
  .author-info{
    padding-bottom: 10px;
    margin-top: 10px;
    text-align: right;
    .auth-avatar{
      display: inline-block;
      width: 30px;
      height: 30px;
      vertical-align: middle;
      background-size: cover;
      background-position: center center;
      border-radius: 50%;
    }
    .name{
      margin-left: 5px;
      font-weight: bold;
    }
  }
  .set-cont{
    padding: 10px;
  }
}
</style>
